/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from '../../ui-elements/icon/icon.component.ngfactory';
import * as import3 from '../../ui-elements/icon/icon.component';
import * as import4 from './group-order-summary-icon.component';
import * as import5 from '../../order/order.model';
import * as import6 from '../group-order.model';
const styles_GroupOrderSummaryIconComponent:any[] = ([] as any[]);
export const RenderType_GroupOrderSummaryIconComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_GroupOrderSummaryIconComponent,
  data: {}
}
);
function View_GroupOrderSummaryIconComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'group-order-summary-count'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'group-order-summary-count';
    const currVal_1:any = (('theme-' + co.countColorPair) + '-color-pair');
    ck(v,1,0,currVal_0,currVal_1);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = co.participantCount;
    ck(v,2,0,currVal_2);
  });
}
function View_GroupOrderSummaryIconComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'group-order-summary'
      ]
      ],[[
        2,
        'highlighted',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon',[[
        'class',
        'group-order-summary-icon'
      ]
    ],(null as any),(null as any),(null as any),import2.View_IconComponent_0,import2.RenderType_IconComponent)),
      import0.ɵdid(573440,(null as any),0,import3.IconComponent,[import0.ChangeDetectorRef],{name: [
        0,
        'name'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_GroupOrderSummaryIconComponent_2)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = 'users';
    ck(v,3,0,currVal_1);
    const currVal_2:any = (co.hasGroupOrder || co.participantCount);
    ck(v,6,0,currVal_2);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.highlighted;
    ck(v,0,0,currVal_0);
  });
}
export function View_GroupOrderSummaryIconComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_GroupOrderSummaryIconComponent_1)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import4.GroupOrderSummaryIconComponent = v.component;
    const currVal_0:any = ((co.hasGroupOrder || co.participantCount) || co.showWithoutGroupOrder);
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_GroupOrderSummaryIconComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-group-order-summary-icon',([] as any[]),(null as any),(null as any),(null as any),View_GroupOrderSummaryIconComponent_0,RenderType_GroupOrderSummaryIconComponent)),
    import0.ɵdid(180224,(null as any),0,import4.GroupOrderSummaryIconComponent,[
      import5.OrderModel,
      import6.GroupOrderModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const GroupOrderSummaryIconComponentNgFactory:import0.ComponentFactory<import4.GroupOrderSummaryIconComponent> = import0.ɵccf('woa-group-order-summary-icon',import4.GroupOrderSummaryIconComponent,View_GroupOrderSummaryIconComponent_Host_0,{
  showWithoutGroupOrder: 'showWithoutGroupOrder',
  countColorPair: 'countColorPair'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/group-order/group-order-summary-icon/group-order-summary-icon.component.ngfactory.ts